import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, Injector } from '@angular/core';
import { Color } from '../models/color.model';
import { ColorService } from '../services/color.service';

@Component({
  selector: 'ng-color-list',
  templateUrl: 'color-list.component.html'
})
export class ColorListComponent extends BaseListComponent<Color> {

   constructor(
    public colorServ:ColorService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(colorServ, injector, 'color', {editUrl:'/admin/settings/color/edit', createUrl:'/admin/settings/color/new'});
  }
 
  protected tableProprieties(): string[] {
    return [
        'Código',
        'Cor'
    ]
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}
  

}
